import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import defaultRoutes from './default'
import { SESSION_CHECK_AUTH } from '@/store/actions.type'
// Session components
const Login = () => import('@/views/session/login')
const Logout = () => import('@/views/session/logout')

// Errors components
const Error404 = () => import('@/views/errors/error-404')
const Error500 = () => import('@/views/errors/error-500')
const Error503 = () => import('@/views/errors/error-503')
const ErrorNetwork = () => import('@/views/errors/error-network')
const ErrorBrowser = () => import('@/views/errors/error-browser')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    defaultRoutes,
    {
      path: '/session/login',
      name: 'login',
      component: Login
    },
    {
      path: '/session/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/500',
      name: 'error-500',
      component: Error500
    },
    {
      path: '/503',
      name: 'error-503',
      component: Error503
    },
    {
      path: '/browser',
      name: 'error-browser',
      component: ErrorBrowser
    },
    {
      path: '/network',
      name: 'error-network',
      component: ErrorNetwork
    },
    {
      path: '*',
      component: Error404
    }
  ]
})

// Navigation guards before each
router.beforeEach((to, from, next) => {
  if (to.matched.some((element) => element.meta.auth)) {
    Promise.all([store.dispatch(SESSION_CHECK_AUTH)]).then(() => {
      if (!store.getters.getIsAuthenticated) {
        next({ name: 'login' })
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

export default router
